export default class RoleItem
{
	constructor(item) 
	{
		if(item===undefined)
		{
			this.RoleId = "";
			this.Name = "";
		}
		else
		{
			this.RoleId = item.roleId;
			this.Name = item.name;
		}
	}
}
